import { useParams } from "react-router-dom";
import PermissionLog from "datasets/pages/settings/types/interfaces/permission-log";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const usePermissionLogs = () => {
  const { datasetId } = useParams();
  return useFetcher<PermissionLog[]>(
    datasetId ? `${VITE_CATALOG_API}/datasets/${datasetId}/permission-logs` : null
  );
};

export default usePermissionLogs;
